import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Link } from '~/lib/react-router-dom';

import { Button, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import OfferSearchForm from '~/components/Common/Forms/OfferSearchForm';
import OfferList from '~/components/Common/OfferListContainer';
import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER } from '~/consts/roles';

import OffersService from '~/services/OffersService';

import { removeQuery } from '~/utils/url';

const urlBuilder = (row: App.Offer) => {
  return `/offers/${row.id_salesforce_external}`;
};

export default function OffersPage() {
  const location = useLocation();
  const [searchString, setSearchString] = useState('');
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    OffersService.getAllLocations().then((response: App.LocationsResponse) => {
      setDestinations(response.result || []);
    });
  }, []);

  const searchQuery = (query: string) => {
    setSearchString(query);

    removeQuery(location, 'page');
  };

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Offers</title>
      </Helmet>

      <PageHeader title="Offers">
        {/* svc-offer gates the rules API on admin and employee, so a wider role list buys a 403. */}
        <PermissionedComponent requiredRoles={[ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]}>
          <Button variant="outlined" color="primary" component={Link} to="/offers/lux-plus-schedule-defaults">
            LuxPlus+ Schedule Defaults
          </Button>
        </PermissionedComponent>
      </PageHeader>

      <OfferSearchForm destinations={destinations} searchQuery={searchQuery} />

      <OfferList urlBuilder={urlBuilder} searchString={searchString} showCountMessage />
    </Container>
  );
}
